import { OrderInfo, PromoCode } from 'src/models/general';
import { LicenseAgreementInfo } from './common';

export type ChildrenProps = {
  children: React.ReactNode;
};

export interface Product {
  uid: string;
  biiId: string;
  maId: string;
  title: string;
  format: string;
  qty: number;
  image?: string;
  amount?: number;
  url: string;
  salableUid: string;
  courseId?: string;
  instructors?: string[];
  digitalProduct?: boolean;
  physicalProduct?: boolean;
  discountAmount?: number;
  brand?: string;
  updating?: boolean;
  updateError?: boolean;
  parentId?: string;
  categoryName?: string;
  typename?: string;
  status: string;
  printOnDemand: boolean;
  licenseAgreementInfo?: LicenseAgreementInfo;
}

export interface ErrorMessage {
  code: string;
  message: string;
}

export type ResponseStatus = 'OK' | 'ERROR';

export interface MergeCartResponseResult {
  status: ResponseStatus;
  mergedProducts: MergedProduct[];
  errors: ErrorMessage[];
}

export interface UpdateQuantityResponseResult {
  status: ResponseStatus;
  errors: string[];
}

export interface GetCartResponseResult {
  status: ResponseStatus,
  errors: string[];
}

export interface UnavailableProduct {
  sku: string;
  uid: string;
  name: string;
  reason: {
    code: string;
    message?: string;
  };
}

export interface MergedProduct {
  maId: string;
  maName: string;
}

export enum DiscountValueType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum DiscountType {
  COUPON_DISCOUNT = 'COUPON-DISCOUNT',
  TARGET_PRICE_DISCOUNT = 'TARGET-PRICE-DISCOUNT',
  ADD_DISCOUNT = 'ADD-DISCOUNT',
  SITEWIDE_PRODUCT_DISCOUNT = 'SITEWIDE-PRODUCT-DISCOUNT',
  SITEWIDE_SITE_ID_DISCOUNT = 'SITEWIDE-SITE-ID-DISCOUNT',
  FREETRIAL = 'FREETRIAL',
}

export enum TrialInterval {
  DAY = 'DAY',
}

export enum ProductMarketRestrictions {
  BILLING_RESTRICTED_COUNTRIES = 'product-billing-restricted-countries',
  SHIPPING_RESTRICTED_COUNTRIES = 'product-shipping-restricted-countries',
}

interface TrialDuration {
  amount: number;
  units: TrialInterval;
}

export interface OrderItemDiscounts {
  itemNumber: string;
  valueType: DiscountValueType;
  discountAmount: number;
  discountValue: number;
  discountType: DiscountType;
  freeTrialDuration?: TrialDuration;
}

export interface Discount {
  itemNumber: string;
  title: string;
  discount: string;
  freeTrialDuration?: TrialDuration;
}

export interface Cart {
  isLoading: boolean;
  isPromoLoading: boolean;
  isFreeTrial: boolean;
  cartId: string | null;
  promoError: string | null;
  promoCode: PromoCode | null;
  currency: string;
  products: Product[];
  orderInfo: OrderInfo;
  removedProducts: UnavailableProduct[];
  marketRestrictedProducts: UnavailableProduct[];
  mergedProducts: MergedProduct[];
  discounts: Discount[];
}

export interface CartCookies {
  cartId: string;
  almToken: string;
  ecomToken: string;
  connectAccessToken: string;
  connectIdToken: string;
  cartTotalItems: string;
}

export interface AlmTokenInfo {
  email: string;
  given_name: string;
  family_name: string;
  name: string; // full name
  exp: number;
}
